import { GetAffectedMeteredEventsResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

type UseAffectedMeteredEventsPayload = Parameters<
  ReturnType<typeof getPrivateApi>['getAffectedMeteredEvents']
>[0];

export function useAffectedMeteredEvents(payload: UseAffectedMeteredEventsPayload) {
  const privateApi = getPrivateApi();

  return useQuery(
    queryKeys.affectedMeteredEvents(payload),
    async ({ signal }) => {
      const getAffectedMeteredEventsResponse = await privateApi.getAffectedMeteredEvents(
        {
          ...payload,
        },
        { signal },
      );

      return GetAffectedMeteredEventsResponseSchema.parse(getAffectedMeteredEventsResponse);
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );
}
